import React from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'
import cx from 'classnames'

const PageLink = (props) => (
  <TransitionLink
    entry={{ delay: 0.3, state: props.state }}
    exit={{ length: 1 }}
    className={cx(props.className, {
      'is-active': props.isActive
    })}
    activeClassName='active'
    onClick={props.onClick}
    to={props.to}>
    {props.children}
  </TransitionLink>
)

export default PageLink